window.tinymce.PluginManager.add('itemprop', function (editor) {
  const intl = editor.getParam('intl');
  let scope = 'ui.form.field.text_editor.itemprop';

  editor.ui.registry.addMenuButton('itemprop', {
    text: intl.t(`${scope}.label`),
    fetch: function (callback) {
      let items = [];

      ['skills', 'responsibilities', 'jobBenefits'].forEach((itemprop) => {
        let item = {
          type: 'menuitem',
          text: intl.t(`${scope}.options.${itemprop}`),
          onAction: function () {
            let current = editor.dom.getAttrib(
              editor.selection.getNode(),
              'itemprop',
            );

            editor.dom.setAttrib(
              editor.selection.getNode(),
              'itemprop',
              current === itemprop ? '' : itemprop,
            );

            editor.dom.setAttrib(
              editor.selection.getNode(),
              'itemproplabel',
              current === itemprop
                ? ''
                : intl.t(`${scope}.options.${itemprop}`),
            );
            editor.undoManager.add();
          },
        };

        items.push(item);
      });

      callback(items);
    },
  });
});
